import { createSelector } from 'reselect';
import { getArmies, getDraft, getMyTeam } from '../pairingSelector';
import { SelectTeamArmiesView } from './view/SelectTeamArmiesView';
import { TeamArmyView } from './view/TeamArmyView';
import { formValueSelector } from 'redux-form';
import { AppState } from '@Redux/store';

const getState = (state: AppState): AppState => state;

// Decorate with connect to read form values
// @ts-ignore
const selector = formValueSelector('create_team'); // <-- same as form name

export const selectTeamArmiesPresenter = createSelector(
  [getState, getDraft, getMyTeam, getArmies],
  (state, draft, myTeam, armiesState): SelectTeamArmiesView => {
    const size = draft.entity?.size ?? 0;
    const versionId = draft.entity?.versionId ?? 0;
    const teamArmies: Array<TeamArmyView> =
      selector(state, 'teamArmies') ?? new Array<TeamArmyView>();

    let addTeamArmies = new Array<TeamArmyView>();
    for (let i = teamArmies.length; i < size; i++) {
      addTeamArmies.push(TeamArmyView.empty());
    }

    const armies = (armiesState.entity ?? [])
      .filter((item) => item.versionId === versionId)
      .filter((item) => item.isLatest);

    return new SelectTeamArmiesView({
      size: size,
      armies:
        armies.map((item) => {
          const selecteable =
            size > teamArmies.filter((x) => x.armyId).length ||
            teamArmies.some((element) => element.armyId === item.id);
          const selected = teamArmies.some(
            (element) => element.armyId === item.id,
          );
          return TeamArmyView.fromArmy(item, selecteable, selected);
        }) ?? new Array<TeamArmyView>(),
      hasError: armiesState.hasError,
      isArmiesLoading: armiesState.isLoading,
      isLoading: draft.isLoading || myTeam.isLoading,
      teamName: myTeam.entity?.name ?? '',
      teamArmies: teamArmies.concat(addTeamArmies),
    });
  },
);
